import { api } from '../index';

export class TechnicalSkillsService {
  static async getTechnicalSkills(params) {
    return api.get('/technical-skills', { params });
  }
}
